import { Component, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'fic-screen-header',
    template: `
        <ng-content select="fic-screen-header-prefix"></ng-content>

        <div class="fic-screen-header-content">
            <ng-content></ng-content>
        </div>

        <ng-content select="fic-screen-header-suffix"></ng-content>
    `,
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./fic-screen-header.component.scss'],
    host: { class: 'fic-screen-header' },
    standalone: false,
})
export class FicScreenHeaderComponent {}
